
// @ts-nocheck
import locale_translation_46json_9c3d854a from "#nuxt-i18n/9c3d854a";
import locale_translation_46json_eec7271f from "#nuxt-i18n/eec7271f";

export const localeCodes =  [
  "en",
  "pl"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_translation_46json_9c3d854a",
      load: () => Promise.resolve(locale_translation_46json_9c3d854a),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_translation_46json_eec7271f",
      load: () => Promise.resolve(locale_translation_46json_eec7271f),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/38629a52" /* webpackChunkName: "config_i18n_46config_46ts_38629a52" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    jit: true,
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "EN",
      files: [
        "/vercel/path0/src/locales/langs/dev/en/translation.json"
      ]
    },
    {
      code: "pl",
      name: "PL",
      files: [
        "/vercel/path0/src/locales/langs/dev/pl/translation.json"
      ]
    }
  ],
  defaultLocale: "pl",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: false,
  langDir: "../src/locales/langs/dev",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    "index/index": {
      en: "",
      pl: false
    },
    "cars/index": {
      en: "/cars",
      pl: "/samochody"
    },
    "short-term/index": {
      en: "/short-term-rental",
      pl: "/wynajem-krotkoterminowy"
    },
    "medium-term/index": {
      en: "/medium-term-rental",
      pl: "/wynajem-srednioterminowy"
    },
    "long-term/index": {
      en: "/long-term-rental",
      pl: "/wynajem-dlugoterminowy"
    },
    "month/index": {
      en: "/for-a-month-rental",
      pl: "/wynajem-auta-na-miesiac"
    },
    "2months/index": {
      en: "/for-a-2-months-rental",
      pl: "/wynajem-auta-na-2-miesiace"
    },
    "3months/index": {
      en: "/for-a-3-months-rental",
      pl: "/wynajem-auta-na-3-miesiace"
    },
    "6months/index": {
      en: "/for-a-6-months-rental",
      pl: "/wynajem-auta-na-6-miesiecy"
    },
    "rent-tesla/index": {
      en: "/rent-tesla",
      pl: "/tesla-wynajem"
    },
    "6bus/index": {
      en: "/6-seat-bus-rental",
      pl: "/wynajem-busa-6-osobowego"
    },
    "7bus/index": {
      en: "/7-seat-bus-rental",
      pl: "/wynajem-busa-7-osobowego"
    },
    "8bus/index": {
      en: "/8-seat-bus-rental",
      pl: "/wynajem-busa-8-osobowego"
    },
    "9bus/index": {
      en: "/9-seat-bus-rental",
      pl: "/wynajem-busa-9-osobowego"
    },
    "bus-rental/index": {
      en: "/passenger-bus-rental",
      pl: "/wynajem-busow-osobowych"
    },
    "delivery-bus-rental/index": {
      en: "/passenger-delivery-bus-rental",
      pl: "/wynajem-busow-dostawczych"
    },
    "refrigeration-van-rental/index": {
      en: "/refrigeration-van-rental",
      pl: "/wynajem-samochodu-chlodnia"
    },
    "insurance-replacement/index": {
      en: "/a-replacement-car-from-the-perpetrators-liability-insurance",
      pl: "/wynajem-z-oc-sprawcy"
    },
    "locations/index": {
      en: "/branches",
      pl: "/oddzialy"
    },
    "contact/index": {
      en: "/contact",
      pl: "/kontakt"
    },
    "about-us/index": {
      en: "/about-us",
      pl: "/onas"
    },
    "car-rental-[urlSlug]/index": {
      en: "/car-rental-[urlSlug]",
      pl: "/wypozyczalnia-samochodow-[urlSlug]"
    },
    "create-new-password/index": {
      en: "/create-new-password",
      pl: "/nowe-haslo"
    },
    "news/[[page]]/index": {
      en: "/news/[[page]]",
      pl: "/aktualnosci/[[page]]"
    },
    "news/[newsID]/[...newsTitle]/index": {
      en: "/post/[newsID]/[...newsTitle]",
      pl: "/aktualnosc/[newsID]/[...newsTitle]"
    },
    "reservation/index": {
      en: "/reservation",
      pl: "/rezerwacja"
    },
    "loyalty-program/index": {
      en: "/loyalty-program",
      pl: "/program-lojalnosciowy"
    },
    "reservation/completed/[orderID]/index": {
      en: "/reservation-summary/[orderID]",
      pl: "/podsumowanie-rezerwacji/[orderID]"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  legacy: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "EN",
    files: [
      {
        path: "/vercel/path0/src/locales/langs/dev/en/translation.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    name: "PL",
    files: [
      {
        path: "/vercel/path0/src/locales/langs/dev/pl/translation.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/